// extracted by mini-css-extract-plugin
export default {"hr":"PanelRegistroPredio_hr__hLq6t","divSoloBorderNaranja":"PanelRegistroPredio_divSoloBorderNaranja__IOChG","labelEspecial":"PanelRegistroPredio_labelEspecial__ZDB3d"};